import {
  MDBAlert, MDBCol, MDBRow, MDBTabs, MDBTabsContent, MDBTabsItem,
  MDBTabsLink, MDBTabsPane
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";


import {
  MDBBreadcrumb,
  MDBBreadcrumbItem
} from "mdb-react-ui-kit";
import { useLocation } from "react-router";
import { getRoleInfo } from "../apiclients/streamsapi_bridge";
import { GeneralSettings } from "../components/editviews/roles/GeneralSettings";
import { RoleUsers } from "../components/editviews/roles/RoleUsers";
import { useAdminContext } from "../components/adminstore/Admin-Context";
import EditWarning from "../components/header/EditWarning";
import UIConstant from "../apiclients/UIConstant";

function SelectedAdminRoleSettings(props) {
  const { t, i18n } = useTranslation();
  const { state: stateData } = useLocation();
  const [roleId, setRoleId] = useState(stateData?.roleId ?? -1);
  const [basicActive, setBasicActive] = useState("tab1");
  const [verticalActive, setVerticalActive] = useState("tab1");
  const [roleInfo, setRoleInfo] = useState({});
  const [roleUpdated, setRoleUpdated] = useState(false);
  const [message, setMessage] = useState("");
  const [defaultRolesInfo, setDefaultRolesInfo] = useState({});
  const [internalError, setInternalError] = useState(false);
  const [reRenderComp, setReRenderComp] = useState(false);
  const [AddUser, setAddUser] = useState(false);
  const closeTogglePopup = () => setAddUser(!AddUser);
  const [existingUsers, setExistingUsers] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [hasPrevilege, setHasPrevilege] = useState(false);
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
 const[usercount, setUserCount] = useState(0)


  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    } else if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }
    setBasicActive(value);
  };

  const handleOk = () => {
    setEdited(false);
    setBasicActive(targetView);
    setShowWarning(false);
  };

  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }
    setVerticalActive(value);
  };

  const [AddAdminRole, setAddAdminRole] = useState(false);
  const toggleShow51 = () => setAddAdminRole(!AddAdminRole);
  const [isDisabled, setIsDisabled] = useState(false);


  useEffect(() => {
    const disabledState = () => {
      const isAdminSession = JSON.parse(sessionStorage.getItem("admin_session"));
      const isAdmin = isAdminSession?.permissions ? !(isAdminSession?.permissions.includes(UIConstant.ALLOW_ADD_DELETE_EDIT_PERMISSION_ROLES)) : false
      setIsDisabled(isAdmin);
    }
    disabledState();
  }, []);

  useEffect(() => {
    if (hasPrevilege) {
      setTimeout(() => {
        setHasPrevilege(false);
      }, 5000);
    }
  }, [hasPrevilege]);

  //fetching the admin Role specific information.
  async function fetchRoleSpeificInfo(roleId) {
    try {
      let apiResponse = await getRoleInfo(JSON.parse(sessionStorage.getItem("admin_session")).siteid, roleId);
      let specificRoleInfo = await apiResponse.json();
      if (apiResponse.status == 200) {
        let rolesInfo = specificRoleInfo?.rolesInfo;
        setRoleInfo(rolesInfo);
        console.log("roleusers:::::::::::",rolesInfo.users)
        setUserCount(rolesInfo.users.length)
        setExistingUsers(rolesInfo.users);
         setDefaultRolesInfo({
          id: rolesInfo.id,
          siteid: rolesInfo.siteid,
          name: rolesInfo.name,
          description: rolesInfo.description,
          role: rolesInfo.role,
          all_locations: rolesInfo.all_locations ?? true,
          permissions: defaultRolePermissions(rolesInfo.permissions),
          added_locs: rolesInfo.added_locs ?? []
        });

      }
    } catch (e) {
      console.log(`Unable to fetch role specific info:${e}`);
    }
  }
  function defaultRolePermissions(rolesInfo) {
    let resObj = {
      "1": false,
      "2": false,
      "3": false,
      "4": false,
      "5": false,
      "6": false,
      "7": false,
      "8": false,
      '9': 1,
      '11': false
    };

    rolesInfo?.forEach(ele => {
      resObj[ele.role_perm_id] = ele.value === 0 ? false : true;
      if (ele.role_perm_id == 9 || ele.role_perm_id == 10) {
        resObj[9] = ele.role_perm_id == 9 ? 1 : 0;
      }
    });
    return resObj;
  }

  useEffect(() => {
    if (roleId != -1) {
      fetchRoleSpeificInfo(roleId);
    }
  }, [roleId, reRenderComp]);

  return (
    <React.Fragment>
      <>
        <MainLinks active={3} />
        <Body
          tablinks={3}
          sublink={53}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a href="/userlanding">
                            <strong>{t("users")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a href="/permissionrolessection">
                            <strong>{t("PermissionRoles")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href=" ">
                            <strong>{roleInfo.name}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                    </h5>
                  </div>
                  <div className="card-body px-0">
                    <div>
                      <h5 className="fw-600">{roleInfo.name}</h5>
                      <p className="mt-1 mb-1 text-secondary">{t("users")} : {usercount} </p>
                      <p className="mt-1 mb-3 text-secondary">
                        {roleInfo.description}
                      </p>
                    </div>
                    <MDBTabs className="mb-3">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab1")}
                          active={basicActive === "tab1"}
                        >
                          {t("settings")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab2")}
                          active={basicActive === "tab2"}
                        >
                          {t("users")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === "tab1"}>
                        <MDBRow>
                          <MDBCol
                            size="2"
                            md="2"
                            lg="2"
                            sm="12"
                            className="col-sm-100 pr-0 leftTabs"
                          >
                            <MDBTabs className="flex-column">
                              <MDBTabsItem>
                                <MDBTabsLink
                                  onClick={() => handleVerticalClick("tab1")}
                                  active={verticalActive === "tab1"}
                                >
                                  {t("general")}
                                </MDBTabsLink>
                              </MDBTabsItem>
                            </MDBTabs>
                          </MDBCol>
                          <MDBCol
                            size="12"
                            md="10"
                            sm="12"
                            pr-0
                            className="col-sm-100 pr-0 leftTabContent"
                          >
                            <MDBTabsContent>
                              <MDBTabsPane open={verticalActive === "tab1"}>
                                {/* Home content */}
                                <GeneralSettings
                                  defaultRolesInfo={defaultRolesInfo}
                                  setReRender={setReRenderComp}
                                  isDisabled={isDisabled}
                                  setErrorMessage={setErrorMessage}
                                  setHasPrevilege={setHasPrevilege}
                                  setEdited={setEdited}
                                />

                              </MDBTabsPane>
                            </MDBTabsContent>
                          </MDBCol>
                        </MDBRow>
                      </MDBTabsPane>
                      {basicActive === "tab2" && <MDBTabsPane open={basicActive === "tab2"} className="me-3">
                        {/* Tab 2 content */}
                        <RoleUsers
                          existingUsers={existingUsers}
                          roleInfo={roleInfo}
                          isDisabled={isDisabled}
                          setErrorMessage={setErrorMessage}
                          setHasPrevilege={setHasPrevilege}
                          setEdited={setEdited}
                          roleName = {roleInfo.name}
                          setUserCount={setUserCount}
                          basicActive={basicActive === 'tab2'}
                        />
                      </MDBTabsPane>
                      }
                    </MDBTabsContent>
                  </div>
                </div>
              </section>

            </>
          }
        />
        {roleUpdated && (
          <MDBAlert
            open
            className="alert-center"
            color="success"
            autohide
            position="bottom-right"
            delay={5000}
            onClose={() => setRoleUpdated(false)}
          >
            <i className="fas fa-check-circle me-3"></i>
            <span className="alert-msg">{message}</span>
          </MDBAlert>
        )}

        {internalError && (<MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={5000}
          onClose={() => setInternalError(false)}
        >Internal Server Error</MDBAlert>)}

        {hasPrevilege && (
          <MDBAlert
            open
            className="alert-center"
            color="danger"
            autohide
            position="bottom-right"
            delay={10000}
          >
            <i className="fas fa-times-circle me-3"></i>
            <span className="alert-msg">{errorMessage}</span>
          </MDBAlert>
        )}

        {showWarning && (
          <EditWarning
            warningToggle={warningToggle}
            setShowWarning={setShowWarning}
            onOk={handleOk}
          />
        )}


        {/* <Footer /> */}
      </>
    </React.Fragment>
  );
}

export default SelectedAdminRoleSettings;
